import { getErrorHandler } from 'common-package/src/utils/errorHandler';
import { HUB_BASE_URL, LANG_LOCAL_STORAGE_KEY } from '@yaotai/common-utils';
import { createClientAxiosInstance } from '@fuxi/common-utils';
import { getCenterUnAuthCb } from '@commonPackage/utils/centerUnAuthCb';

export const { GateWayInstance } = createClientAxiosInstance({
  baseUrl: HUB_BASE_URL,
  envGateWayBaseUrl: import.meta.env.VITE_GATEWAY_BASE_URL,
  secret: import.meta.env.VITE_YEYING_SECRET_KEY!,
  username: import.meta.env.VITE_YEYING_SECRET_USERNAME!,
  apiKey: import.meta.env.VITE_YEYING_API_KEY!,
  errorHandler: getErrorHandler({
    monorepoType: 'center',
    unAuthCb: getCenterUnAuthCb(),
  }),
  extraConfig: {
    localStorageLangKey: LANG_LOCAL_STORAGE_KEY,
  },
});

export default GateWayInstance;
